<template>
	<div class="playmode">
		<div class="rotateDevice">
			<!-- <h2>Gently rotate your device.. </h2> -->
			<img src="../ui-assets/rotate-dev.svg">
		</div>

		<div class="fullscreen">
			<h2>Press yellow button below</h2>
			
			<div class="button">
				<button class="good" @click="openFullscreen()"> Open Full Screen</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
  name: 'Playmode',
  data (){
    return {}
  }, methods: {
  		/* View in fullscreen */
  		openFullscreen(){
		var elem = document.documentElement;
		var body = document.body;

		  if (elem.requestFullscreen) {
		    elem.requestFullscreen();
		  } else if (elem.mozRequestFullScreen) { /* Firefox */
		    elem.mozRequestFullScreen();
		  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
		    elem.webkitRequestFullscreen();
		  } else if (elem.msRequestFullscreen) { /* IE/Edge */
		    elem.msRequestFullscreen();
		  }
			body.classList.add("playmodeEnabled");

		}
  },
  created: function (){
  	var body = document.body;


	if (document.addEventListener)
	{
	    document.addEventListener('webkitfullscreenchange', exitHandler, false);
	    document.addEventListener('mozfullscreenchange', exitHandler, false);
	    document.addEventListener('fullscreenchange', exitHandler, false);
	    document.addEventListener('MSFullscreenChange', exitHandler, false);
	}

	function exitHandler()
	{
	    if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement)
	    {
	    	body.classList.add("playmodeEnabled");

	    } else {

	    	body.classList.remove("playmodeEnabled");
	    }
	}
   }
}
</script>
